// extracted by mini-css-extract-plugin
module.exports = {"container":"Fade_container__12R5w ResponsiveBackground_background__1FkTW"};